import { store } from '@betacrew/jars-flux';
import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import { componentKey, setClickedRecipientData, setErrorPayerIds, setGridViewBoxOptionsList, setGridViewPayerList, setIsFinalFormSubmittedSuccessfully, setIsSubmitBtnDisabled, setLoadingState, setPayerUpdationSuccessful, setRecipientEditSuccessfull, setReloadFormGridPageFieldsData, setReloadGridRecords, setSaveImportFormSuccessData, setSubmittedRecordsHasErrors, updateImportGridRecords } from './ImportDataGridViewSlice';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { GRID_VIEW_COLORS, IMPORT_DATA_LOADING_STATES } from './constants';
import Forms from '../../../../libs/utility/formsutility/Forms';
import FormsDataService from '../../../../services/FormsDataService';
import General from '../../../../libs/utility/General';
import Payer from '../../../../libs/utility/Payer';
import { PAYER_TYPE_TITLE } from '../addpayernew/createone/getpayertype/constants';
import { PAGE_STATE } from '../../constants/constants';
import { RECIPIENT_TYPE_TITLE } from '../addrecipientnew/getrecipienttype/constants';

export const { getFormGridRecords, getFormGridPageFieldsData, setSelectedPayerList, checkSelectedPayersValid, applyBoxToSelectedRecords, gridViewDownloadReports, updateSingleBox, proceedWithoutUpdatingTin, deleteSingleRecord, submitEditedPayer, getRecipientDataForEdit, submitEditedRecipient, finalSubmitSelectedRecords } = {
    getFormGridRecords: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_FORM_GRID_RECORDS",
            payload: payload
        }
    },
    getFormGridPageFieldsData: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_FORM_GRID_PAGE_FIELDS_DATA",
            payload: payload
        }
    },
    setSelectedPayerList: (payload) => {
        return {
            type: "BATCH_IMPORT/SET_SELECTED_PAYER_LIST",
            payload: payload
        }
    },
    checkSelectedPayersValid: (payload) => {
        return {
            type: "BATCH_IMPORT/CHECK_SELECTED_PAYERS_VALID",
            payload: payload
        }
    },
    applyBoxToSelectedRecords: (payload) => {
        return {
            type: "BATCH_IMPORT/APPLY_BOX_TO_BULK_SELECTED",
            payload: payload
        }
    },
    gridViewDownloadReports: (payload) => {
        return {
            type: "BATCH_IMPORT/GRID_DOWNLOAD_REPORTS",
            payload: payload
        }
    },
    updateSingleBox: (payload) => {
        return {
            type: "BATCH_IMPORT/UPDATE_SINGLE_BOX",
            payload: payload
        }
    },
    proceedWithoutUpdatingTin: (payload) => {
        return {
            type: "BATCH_IMPORT/PROCEED_WITHOUT_UPDATING_TIN",
            payload: payload
        }
    },
    deleteSingleRecord: (payload) => {
        return {
            type: "BATCH_IMPORT/DELETE_SINGLE_BOX",
            payload: payload
        }
    },
    submitEditedPayer: (payload) => {
        return {
            type: "BATCH_IMPORT/SUBMIT_EDITED_PAYER",
            payload: payload
        }
    },
    getRecipientDataForEdit: (payload) => {
        return {
            type: "BATCH_IMPORT/GET_RECIPIENT_DATA",
            payload: payload
        }
    },
    submitEditedRecipient: (payload) => {
        return {
            type: "BATCH_IMPORT/SUBMIT_EDITED_RECIPIENT",
            payload: payload
        }
    },
    finalSubmitSelectedRecords: (payload) => {
        return {
            type: "BATCH_IMPORT/FINAL_SUBMIT_SELECTED_RECORDS",
            payload: payload
        }
    },
}

function* getFormGridRecordsAsync(action){
    try {
        const {formId, requestData, errorPayerIds, year} = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING }));
        const response = yield FormsDataService.getFormGridRecordsList(formId, requestData, year);        
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error in fetching records", message: response?.data?.Message }));
            }else if(response?.data?.Status === 1) {
                const responseData = response?.data?.Data?.Data ?? [];
                const updatedDataArray = responseData.map((obj) => {
                    const { payerColor, recipientColor } = Forms.getPayerAndRecipientColorErrorStatus(obj?.Flag ?? false, obj?.PayerTIN, errorPayerIds);
                    let finalPayerColor = payerColor;
                    if(finalPayerColor !== GRID_VIEW_COLORS.RED && Array.isArray(response?.data?.Data?.PayersWithRecipientErrors) && response?.data?.Data?.PayersWithRecipientErrors.includes(obj?.PayerTIN)){
                        finalPayerColor = GRID_VIEW_COLORS.YELLOW;
                    }                    
                    return { 
                        ...obj, 
                        payerColor: finalPayerColor, 
                        recipientColor: recipientColor,
                        PayerErrors: ((obj?.PayerErrors ?? "").replaceAll("PTIN: "+obj?.PayerTIN+" |", "")) ?? "",
                    };
                });
                    yield put(updateImportGridRecords({
                        totalRecords: response?.data?.Data?.Total ?? 0,
                        totalAmount: response?.data?.Data?.TotalAmount ?? 0,
                        isAllSelected: response?.data?.Data?.IsAllSelected ?? false,
                        records: updatedDataArray,
                        hasErrors: response?.data?.Data?.HasErrors ?? false,
                        pageTotalAmount: response?.data?.Data?.PageTotalAmount ?? 0,
                        hasRecipientWithoutTIN: response?.data?.Data?.HasRecipientWithoutTIN ?? false,
                    }))                    
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_READY }))
    }
}

function* getFormGridPageFieldsDataAsync(action){
    try {
        const { formId, loadedPayerListFromView, year, showPayerDropdownFlag, signedInUser } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_LOADING }));
        const response = yield FormsDataService.getFormGridFieldsData(formId, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error in fetching data", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                let gridViewPayerList = response?.data?.Data?.PayerList ?? [];
                const gridViewBoxOptionsList = response?.data?.Data?.BoxList ?? [];
                General.addOptionAndValueKeys(gridViewPayerList, "Name", "Id");
                let checkedCount = 0;
                gridViewPayerList = gridViewPayerList.map((obj) => {
                    const matchingObject = loadedPayerListFromView.find(
                        (item) => item.Id === obj.Id && item?.checked === true
                    );

                    let updatedObj = obj;

                    if(signedInUser?.MultiplePayerLocation && updatedObj?.DisregardedEntity != ''){
                        updatedObj = {
                            ...updatedObj,
                            label: `${updatedObj?.label} (${updatedObj?.DisregardedEntity})`
                        }
                    }
                  
                    if (matchingObject) {
                        checkedCount++;
                        return { ...updatedObj, checked: matchingObject.checked };
                    } else {
                        return updatedObj;
                    }
                });
                if(checkedCount === 0 && gridViewPayerList.length > 0){
                    gridViewPayerList[0].checked = true;
                }
                yield put(setGridViewPayerList(gridViewPayerList));

                const {selectedPayerIdsArray, selectedPayerDisregardedEntitiesArray} = Forms.importGridPageSelectedPayerIds(gridViewPayerList, signedInUser?.MultiplePayerLocation);
                
                General.addOptionAndValueKeys(gridViewBoxOptionsList, "ActionName", "ActionId");
                yield put(setGridViewBoxOptionsList(gridViewBoxOptionsList));

                if(gridViewPayerList.length > 0 && showPayerDropdownFlag){
                    yield call(setSelectedPayerListAsync, { payload: {formId: formId, payerList: {Ids: selectedPayerIdsArray, DisregardedIds:  selectedPayerDisregardedEntitiesArray}, year: year}});
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_READY }))
    }
}

function* setSelectedPayerListAsync(action) {
    try {
        const {formId, payerList, year, signedInUser} = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_SELECTED_PAYERS_LOADING }));
        const response = yield FormsDataService.setSelectedPayerList(formId, payerList, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error in setting payer", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield call(checkSelectedPayersValidAsync, {payload: {
                    formId: formId,
                    payerIds: {Ids: payerList?.Ids},
                    year: year,
                }});
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_SELECTED_PAYERS_READY }))
    }
}

function* checkSelectedPayersValidAsync(action) {
    try {
        const { formId, payerIds, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_SELECTED_PAYERS_LOADING }));
        const response = yield FormsDataService.checkPayerValid(formId, payerIds, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                let newErrorPayerIds = {};
                if(response?.data?.Data){
                    newErrorPayerIds = response.data.Data.reduce((result, obj) => {
                        const { PIdNumber } = obj;
                        result[PIdNumber] = true;
                        return result;
                    }, {});
                }
                yield put(setErrorPayerIds(newErrorPayerIds));
                yield put(setReloadGridRecords(true));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_DOWNLOAD_ACTION_READY }))
    }
}

function* applyBoxToSelectedRecordsAsync(action) {
    try {
        const { formId, requestBody, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING }));
        const response = yield FormsDataService.applyBoxToSelectedRecords(formId, requestBody, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                let errorMessage = `${(response.data?.Data?.PayerErrors ?? "")} ${(response.data?.Data?.PayeeErrors ?? "")} ${(response.data?.Data?.OtherErrors ?? "")}`.trim();            
                if(errorMessage.length === 0){
                    errorMessage = response?.data?.Message ?? "Error in updating record";
                }
                yield put(addNotifications({ heading: "Error", message: errorMessage, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield put(setReloadGridRecords(true));
                yield put(addNotifications({ heading: "Success", message: "Records updated successfully", variant: TOASTER_VARIANT.SUCCESS }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_READY }))
    }
}

function* gridViewDownloadReportsAsync(action){
    try {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_DOWNLOAD_ACTION_LOADING }));
        const { formId, reportType, year } = action.payload;
        const response = yield FormsDataService.downloadExcelReport(formId, reportType, year);     
        if(response?.data){
            if (response?.data.Status) {
                const { Base64, Name } = response?.data?.Data;
                General.downloadFile(Base64, Name);
            } else {
                yield put(addNotifications({ heading: "Something went wrong", message: response?.data?.Message }));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_DOWNLOAD_ACTION_READY }))
    }
}

function* updateSingleBoxAsync(action) {
    try {
        const { formId, requestBody, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_EDIT_BOX_ACTION_LOADING }));
        const response = yield FormsDataService.updateSingleBox(formId, requestBody, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                let errorMessage = `${(response.data?.Data?.PayerErrors ?? "")} ${(response.data?.Data?.PayeeErrors ?? "")} ${(response.data?.Data?.OtherErrors ?? "")}`.trim();            
                if(errorMessage.length === 0){
                    errorMessage = response?.data?.Message ?? "Error in updating record";
                }
                yield put(addNotifications({ heading: "Error", message: errorMessage, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield put(setReloadGridRecords(true));
                yield put(addNotifications({ heading: "Success", message: "Box updated successfully", variant: TOASTER_VARIANT.SUCCESS }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_EDIT_BOX_ACTION_READY }))
    }
}

function* proceedWithoutUpdatingTinAsync(action){
    try {
        const { formId, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING }));
        const response = yield FormsDataService.updateTinNotProvided(formId, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield put(setReloadGridRecords(true));
                yield put(updateImportGridRecords({
                    hasRecipientWithoutTIN: false
                }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_READY }))
    }
}

function* deleteSingleRecordAsync(action) {
    try {
        const { formId, requestBody, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING }));
        const response = yield FormsDataService.deleteSingleRecord(formId, requestBody, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }else if(response?.data?.Status === 1) {
                yield put(setReloadGridRecords(true));
                yield put(addNotifications({ heading: "Success", message: "Record deleted successfully", variant: TOASTER_VARIANT.SUCCESS }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_READY }))
    }
}

function* submitEditedPayerAsync(action) {
    try {

        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_PAYER_LOADING }))

        const { PayerType, basicInfo, addressInformation, optionalInformation, zipCodeValidationSuccess, PayerDetailId, UserId } = action.payload.payerData;
        const { oldPayerIdNumber, oldPayerDisregardedEntity, oldPayerName, formId, year, mappingId } = action.payload;
        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the payer",
                variant: TOASTER_VARIANT.DANGER
            }));

            yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_PAYER_READY }))

            return;
        }

        const payerData = {
            OldPayerIdNumber: oldPayerIdNumber,
            OldPayerDisregardedEntity: oldPayerDisregardedEntity,
            OldPayerName: oldPayerName,
            PayerId: PayerDetailId,
            PayerType,
            TIN: Payer.removeHyphens(basicInfo.TIN.value),
            Userid: UserId,

            IdType: PayerType == PAYER_TYPE_TITLE.INDIVIDUAL ? "SSN" : "EIN",

            PayerFirstName: basicInfo.PayerFirstName?.value,
            PayerMiddleName: basicInfo.PayerMiddleName?.value,
            PayerLastName: basicInfo.PayerLastName?.value,
            PayerEmail: basicInfo.PayerEmail?.value,
            PayerPhNo: basicInfo.PayerPhNo?.value,
            PayerFileType: basicInfo.PayerFileType?.value,
            PayerSuffix: basicInfo.PayerSuffix?.value,

            PayerAddress: addressInformation?.PayerAddress?.value,
            PayerAddress2: addressInformation?.PayerAddress2?.value,
            PayerCountry: addressInformation?.PayerCountry?.value,
            PayerState: addressInformation?.PayerState?.value,
            PayerCity: addressInformation?.PayerCity?.value,
            PayerZIP: addressInformation?.PayerZIP?.value,

            DisregardedEntity: optionalInformation?.DisregardedEntity?.value,
            PayerClientId: optionalInformation?.ClientID?.value,
            UnMaskRecipientTIN: optionalInformation?.UnMaskRecipientTIN?.value,
            Stateid: optionalInformation?.StateID?.value,
            GroupID: optionalInformation?.GroupID?.value,
        }

        const response = yield FormsDataService.submitEditedPayer(formId, payerData, year, mappingId);

        if (response.data.Status) {
            yield put(setPayerUpdationSuccessful(true));
            yield put(setReloadFormGridPageFieldsData(true));
            yield put(addNotifications({ heading: "Success", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }))
        } else {
            yield put(addNotifications({ heading: "Failed to edit the payer", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        yield put(setPayerUpdationSuccessful(false))
        yield put(addNotifications({ heading: "Failed to edit the payer", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_PAYER_READY }));
    }

}

function* getRecipientDataForEditAsync (action){
    try {
        const { formId, recipientName, year, mappingId } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING, message: "Fetching recipient..." }));
        const response = yield FormsDataService.getRecipientDataForEdit(formId, recipientName, year, mappingId);
        if(response?.data?.Status === 0){
            yield put(addNotifications({ heading: "Error", message: response?.data?.message ?? "Error in fetching recipient", variant: TOASTER_VARIANT.DANGER }));
        }else if(response?.data?.Status === 1) {
            yield put(setClickedRecipientData(response?.data?.Data[0]));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_READY }))
    }
}

function* submitEditedRecipientAsync(action){
    try {

        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_RECIPIENT_LOADING }))

        const { RecipientType, recipientBasicInfo, recipientAddressInformation, recipientOptionalInformation, zipCodeValidationSuccess, RequestType, selectedPayer, selectedRecipient, RecipentDetailId } = action.payload.editedRecipientData;
        const {oldRecipientName, formId, year, mappingId} = action.payload;

        if (!zipCodeValidationSuccess) {
            yield put(addNotifications({
                heading: "Zip Code Not Validated",
                message: "Please validate the zip code before adding the payer",
            }));

            yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_RECIPIENT_READY }))
            return;
        }

        const recipientData = {
            OldPayeeName: oldRecipientName,
            PayeeType: RecipientType,
            PayeeFileType: recipientBasicInfo.RecipientType === RECIPIENT_TYPE_TITLE.INDIVIDUAL ? "SSN" : "EIN",
            PayeeTIN: Payer.removeHyphens(recipientBasicInfo.RecipientTIN.value),
            PayerID: selectedPayer?.PayerDetailId,


            PayeeFirstName: recipientBasicInfo.RecipientFirstName?.value,
            PayeeMiddleName: recipientBasicInfo.RecipientMiddleName?.value,
            PayeeLastName: recipientBasicInfo.RecipientLastName?.value,
            PayeeSuffix: recipientBasicInfo.RecipientSuffix?.value,

            PayeeEmail: recipientBasicInfo.RecipientEmail?.value,
            PayeePhNo: recipientBasicInfo.RecipientPhNo?.value,

            PayeeAddress: recipientAddressInformation?.RecipientAddress?.value,
            PayeeAddress2: recipientAddressInformation?.RecipientAddress2?.value,
            PayeeCity: recipientAddressInformation?.RecipientCity?.value,
            PayeeState: recipientAddressInformation?.RecipientState?.value,
            PayeeCountry: recipientAddressInformation?.RecipientCountry?.value,
            PayeeZIP: recipientAddressInformation?.RecipientZIP?.value,

            AttentionTo: recipientOptionalInformation?.AttentionTo?.value,
            PayeeID: selectedRecipient?.RecipentDetailId || RecipentDetailId,

            isW9Request: RequestType === 'W-9 Request' ? true : false,
            FTIN: "",
            GIIN: "",
            ClientRecipientId: recipientOptionalInformation?.Isrecipientclient?.value,
            recipientTaxIDIsPresent: recipientBasicInfo.RecipientTIN.value === "" ? true : false,
        }

        const response = yield FormsDataService.submitEditedRecipient(formId, recipientData, year, mappingId);

        if (response.data.Status) {
            yield put(setRecipientEditSuccessfull(true));
            yield put(addNotifications({ heading: "Recipient Updated Successfully", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to update the recipient details", message: response?.data?.Message }));
        }

    } catch (error) {
        console.error("err: ", error)
        yield put(setRecipientEditSuccessfull(false))
        yield put(addNotifications({ heading: "Failed to update the recipient details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_RECIPIENT_READY }))
    }
}

function* finalSubmitSelectedRecordsAsync(action) {
    try {
        const { formId, requestBody, year } = action.payload;
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_LOADING }));
        yield put(setIsSubmitBtnDisabled(true));
        const response = yield FormsDataService.bulkImportSubmit(formId, requestBody, year);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({ heading: "Error", message: response?.data?.Data ?? response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
                yield put(setSubmittedRecordsHasErrors(true));
            }else if(response?.data?.Status === 1) {
                yield put(setSaveImportFormSuccessData(response?.data?.Data));
                yield put(setIsFinalFormSubmittedSuccessfully(true));
                yield put(addNotifications({ heading: "Success", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setIsSubmitBtnDisabled(false));
        yield put(setLoadingState({ state: IMPORT_DATA_LOADING_STATES.GRID_PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(getFormGridRecords().type, getFormGridRecordsAsync),
        takeEvery(getFormGridPageFieldsData().type, getFormGridPageFieldsDataAsync),
        takeLeading(setSelectedPayerList().type, setSelectedPayerListAsync),
        takeLeading(checkSelectedPayersValid().type, checkSelectedPayersValidAsync),
        takeLeading(applyBoxToSelectedRecords().type, applyBoxToSelectedRecordsAsync),
        takeLeading(gridViewDownloadReports().type, gridViewDownloadReportsAsync),
        takeLeading(updateSingleBox().type, updateSingleBoxAsync),
        takeLeading(proceedWithoutUpdatingTin().type, proceedWithoutUpdatingTinAsync),
        takeLeading(deleteSingleRecord().type, deleteSingleRecordAsync),
        takeLeading(submitEditedPayer().type, submitEditedPayerAsync),
        takeLeading(submitEditedRecipient().type, submitEditedRecipientAsync),
        takeLeading(getRecipientDataForEdit().type, getRecipientDataForEditAsync),
        takeLeading(finalSubmitSelectedRecords().type, finalSubmitSelectedRecordsAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);